import { render, staticRenderFns } from "./DossierBrowseExtraButtonInfo.vue?vue&type=template&id=17f0ceaf&"
import script from "./DossierBrowseExtraButtonInfo.vue?vue&type=script&lang=ts&"
export * from "./DossierBrowseExtraButtonInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f0ceaf')) {
      api.createRecord('17f0ceaf', component.options)
    } else {
      api.reload('17f0ceaf', component.options)
    }
    module.hot.accept("./DossierBrowseExtraButtonInfo.vue?vue&type=template&id=17f0ceaf&", function () {
      api.rerender('17f0ceaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierBrowseExtraButtonInfo.vue"
export default component.exports